import type { Client, RequestContext } from "../client";
import type { RouteArgs } from "../resolver";
import type { ModifyDefaultRetentionPolicyCommand, SpaceDefaultRetentionPolicyResource, SpaceDefaultRetentionPolicyTypeResource } from "../resources";
type GetDefaultRetentionPolicyArgs = {
    retentionType: string;
} & RouteArgs;
export class SpaceDefaultRetentionPolicyRepository {
    protected client: Client;
    protected requestContext: RequestContext;
    constructor(client: Client, requestContext: RequestContext) {
        this.client = client;
        this.requestContext = requestContext;
    }
    /**
     * Gets the default retention policy for the specified type
     * @param retentionType The type of retention policy to fetch (e.g., "MachinePackageCache", "LifecycleRetention")
     * @returns Promise that resolves to the default retention policy response
     */
    getDefaultByType(retentionType: string): Promise<SpaceDefaultRetentionPolicyTypeResource> {
        return this.client.get(this.requestContext, "~/api/{spaceId}/retentionpolicies{?retentionType}", { retentionType });
    }
    updateDefault(command: ModifyDefaultRetentionPolicyCommand): Promise<SpaceDefaultRetentionPolicyResource> {
        return this.client.put<SpaceDefaultRetentionPolicyResource>(this.requestContext, `~/api/{spaceId}/retentionpolicies/{id}`, command, { id: command.Id });
    }
}
